export default {
  title: 'Pedido n.º {{number}}',
  labels: {
    item: '{{count}} artículo',
    item_other: '{{count}} artículos',
  },
  buttons: {
    details: 'Detalles',
  },
  fulfillment_statuses: {
    created: 'Creado',
    reviewed: 'Revisado',
    accepted: 'Aceptado',
    preparing: 'Preparando',
    ready: 'Listo',
    on_delivery: 'En reparto',
    picked: 'Recogido',
    rejected: 'Rechazado',
  },
};
